
import store from "@/store/vuex";
import { default_post, default_get } from "./default";

export function reopenRequest(hash) {
  const idVinculo = store.getters.getIdVinculo;
  return default_post({ hash, idVinculo }, "/paas/classesRequest/reopen");
}

export const getRequestInfo = async (hash) => {
  return default_get(`/paas/classesRequest/validateLink?hash=${hash}`);
}

//Get report from backend
export const toggleDefaultPreference = () => {
  return default_post(
    {},
    "/paas/classesRequest/toggleDefaultPreference"
  );
};

export const duplicateRequest = request => {
  return default_post(
    { ...request },
    "/paas/classesRequest/duplicate"
  );
};

export const duplicateRequestAndUpdate = request => {
  return default_post(
    { ...request },
    "/paas/classesRequest/duplicateAndUpdate"
  );
};

export const resetRequest = async(hash) => {
  return default_post({ hash }, "/paas/classesRequest/reset");
}

export const deletePaasRequest = async (hash) => {
  return default_post({ hash }, "/paas/classesRequest/remove");
}

export const deletePaasClassesRequest = async (hash) => {
  return default_post({ hash }, "/paas/classesRequest/removeClassesRequest");
}

export const getRequestsAndClasses = async () => {
  const idVinculo = store.getters.getIdVinculo;
  return default_get(`/paas/classesRequest?idVinculo=${idVinculo}`);
}

export const getRequestsRoomGroup = async () => {
  const idVinculo = store.getters.getIdVinculo;
  return default_get(`/paas/classesRequest/roomGroup?idVinculo=${idVinculo}`);
}

export const updatePreferences = async (preferences) => {
  const idVinculo = store.getters.getIdVinculo;
  return default_post({ preferences, idVinculo }, "/paas/classesRequest/updatePreferences");
}

export const createPaasRequest = async (name, preferences = undefined) => {
  const idVinculo = store.getters.getIdVinculo;
  return default_post({ idVinculo, name, preferences }, "/paas/classesRequest/add");
}

export const editRoomGroupRequest = async (id) => {
  const idVinculo = store.getters.getIdVinculo;
  return default_post({ idVinculo, id }, "/paas/classesRequest/addRoomGroup");
}


export const sendPaasClassesRequest = async (_classes, hash, admin = false) => {

    const author = store.getters.getUserName;

    let classes = _classes.map(e => {
      return {
        ...e,
        id: isNaN(Number(e.id)) ? undefined : e.id,
        author: admin ? e.author ?? author : author,
        hash: hash,
      };
    });

    if(admin) {
      return default_post({ classes }, "/paas/classesRequest/addClasses/admin")
    }else {
      return default_post({ classes }, "/paas/classesRequest/addClasses")
    }
  
}


